import React, { useContext } from 'react';
import classnames from 'classnames';
import { IconSize } from '../../Icons/IconWrap';
import { ActionBarContext } from '../ActionBarContext';
import CommentStat from '../_partials/CommentStat';
import ShareStat from '../_partials/ShareStat';
import LoveStat from '../_partials/LoveStat';
import DeviationFlags from '../_partials/DeviationFlags';
import FavouriteStat from '../_partials/FavouriteStat';
import OwnerControls from '../_partials/OwnerControls';
import MoreMenu from '../_partials/MoreMenu';
import IconsWrapper from './IconsWrapper';
import { useDeviationAttributes } from '../_partials/hooks/useDeviationAttributes';
import { useFlag } from '../../redux/flags/hooks/useFlag';
import s from './ActionBarMobile.scss';
export var ActionBarMobile = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner, loveMeterActive = _a.loveMeterActive;
    var actionBarType = useContext(ActionBarContext);
    var loveFeatureEnabled = useFlag('love_meter');
    var _b = useDeviationAttributes(deviation, isOwner), isLoveable = _b.isLoveable, isCommentable = _b.isCommentable, isFavouritable = _b.isFavouritable, isShareable = _b.isShareable, isEditable = _b.isEditable, hasFlag = _b.hasFlag;
    return (React.createElement("div", { className: classnames(s['root'], actionBarType === 'secondary' && s['secondary'], loveMeterActive && s['love-mode']) },
        React.createElement(IconsWrapper, null,
            isCommentable && React.createElement(CommentStat, { deviation: deviation }),
            isShareable && React.createElement(ShareStat, { deviation: deviation }),
            loveFeatureEnabled && !isOwner && isLoveable && (React.createElement(LoveStat, { isOwner: isOwner, deviation: deviation })),
            isFavouritable && !isOwner && (React.createElement(FavouriteStat, { isOwner: isOwner, deviation: deviation, actionBarType: actionBarType })),
            isEditable && React.createElement(OwnerControls, { deviation: deviation }),
            !isOwner && React.createElement(MoreMenu, { deviation: deviation, size: IconSize.SMALL })),
        React.createElement("div", { className: s['flag'] }, hasFlag && React.createElement(DeviationFlags, { deviation: deviation }))));
};
export default ActionBarMobile;
//# sourceMappingURL=ActionBarMobile.js.map